export function resolveSequenceType(cart, sessionStore) {
  const state = sessionStore.getState();
  const { preorderSequence } = state;

  if (cart?.isReturn === true || cart?.isReturn === "Y") return "regular";

  if ((cart?.layAway === "Y" || cart?.isAdvance === "Y") && preorderSequence?.prefix) {
    return "preorder";
  }

  return "regular";
}

export function generateDocumentNo(sequence) {
  if (!sequence) return null;
  const prefix = sequence.prefix || "";
  const suffix = sequence.suffix || "";
  const nextNo = (sequence.nextNo || 0) + 1;
  return `${prefix}${nextNo}${suffix}`;
}

export async function getLocalMaxSequence(dbAdapter, prefix) {
  if (!prefix) return 0;
  const allOrders = await dbAdapter.orders.toArray();
  let maxSeq = 0;
  for (const order of allOrders) {
    if (order.documentno?.startsWith(prefix)) {
      const seqPart = parseInt(order.documentno.slice(prefix.length), 10);
      if (!isNaN(seqPart) && seqPart > maxSeq) maxSeq = seqPart;
    }
  }
  return maxSeq;
}
